var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReverseConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.424,
    height: 90.943,
    viewBox: "0 0 94.424 90.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confetti",
    transform: "translate(36.794 37.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M51.718,57.685,29.337,14.959a3.494,3.494,0,0,0-5.567-.849L5.785,32.1a3.494,3.494,0,0,0,.849,5.567L49.359,60.044a1.747,1.747,0,0,0,2.359-2.359Z",
    transform: "translate(-4.76 -13.086)",
    fill: "#ffcc5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M5.787,32.1,23.772,14.11a3.494,3.494,0,0,1,5.567.849l.2.377L22.99,21.881a10.483,10.483,0,0,0,2.547,16.7L47.824,50.256l3.893,7.429a1.747,1.747,0,0,1-2.359,2.359L6.632,37.662A3.494,3.494,0,0,1,5.787,32.1Z",
    transform: "translate(-4.762 -13.086)",
    fill: "#f7b546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M41.538,53.237,37.16,50.945l11.13-3.477,1.646,3.145Zm4.019-10.986L29.9,47.143,25.523,44.85l18.384-5.745Zm-4.378-8.362-22.909,7.16-4.378-2.292,25.638-8.013ZM36.8,25.53,6.839,34.891a3.4,3.4,0,0,1-1.261-3.267l29.569-9.239L36.8,25.53Zm-4.378-8.359-19.429,6.07,5.325-5.322,12.457-3.893Z",
    transform: "translate(-5.454 -10.741)",
    fill: "#f47423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M5.575,31.113,20.664,26.4a10.536,10.536,0,0,0,.566,3.484l-14.4,4.5a3.512,3.512,0,0,1-1.059-1.415l-.049-.122a3.449,3.449,0,0,1-.15-1.73ZM25.518,44.339l10.745-3.358,4.378,2.292L29.9,46.631l-1.02-.535ZM23.68,19.025c-.15.15-.241.325-.377.482L12.987,22.733l5.325-5.326,10.165-3.176-4.8,4.794ZM49.929,50.1l-8.4,2.624-4.378-2.292L47.9,47.075l.615.325Zm-23.7-14.376,2.778,1.457L18.26,40.541l-4.378-2.292L24.889,34.81a11.292,11.292,0,0,0,1.338.916Z",
    transform: "translate(-5.449 -10.23)",
    fill: "#ed5d25"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star",
    "data-name": "Icon akar-star",
    d: "M12.4,3.545a.855.855,0,0,0-1.594,0L9.029,8.481a.852.852,0,0,1-.8.545H3.853a.838.838,0,0,0-.526,1.5l3.116,2.8a.833.833,0,0,1,.277.94L5.582,19.093a.848.848,0,0,0,1.3.963l4.233-2.686a.861.861,0,0,1,.99,0l4.233,2.686a.849.849,0,0,0,1.3-.963L16.5,14.27a.833.833,0,0,1,.277-.94l3.116-2.8a.838.838,0,0,0-.525-1.5H14.985a.851.851,0,0,1-.8-.545L12.406,3.545Z",
    transform: "translate(74.208 70.727)",
    fill: "#07b7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-2",
    "data-name": "Icon akar-star",
    d: "M8.726,3.332a.521.521,0,0,0-.971,0L6.67,6.337a.519.519,0,0,1-.485.332H3.519a.51.51,0,0,0-.32.914L5.1,9.289a.507.507,0,0,1,.169.572L4.572,12.8a.517.517,0,0,0,.79.586L7.939,11.75a.524.524,0,0,1,.6,0l2.577,1.635a.517.517,0,0,0,.79-.586l-.693-2.937a.507.507,0,0,1,.169-.572l1.9-1.707a.51.51,0,0,0-.32-.914H10.3a.518.518,0,0,1-.485-.332L8.726,3.332Z",
    transform: "translate(33.053 -3)",
    fill: "#fcb424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-3",
    "data-name": "Icon akar-star",
    d: "M8.726,3.332a.521.521,0,0,0-.971,0L6.67,6.337a.519.519,0,0,1-.485.332H3.519a.51.51,0,0,0-.32.914L5.1,9.289a.507.507,0,0,1,.169.572L4.572,12.8a.517.517,0,0,0,.79.586L7.939,11.75a.524.524,0,0,1,.6,0l2.577,1.635a.517.517,0,0,0,.79-.586l-.693-2.937a.507.507,0,0,1,.169-.572l1.9-1.707a.51.51,0,0,0-.32-.914H10.3a.518.518,0,0,1-.485-.332L8.726,3.332Z",
    transform: "translate(50.053 19.586)",
    fill: "#fcb424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-4",
    "data-name": "Icon akar-star",
    d: "M8.726,3.332a.521.521,0,0,0-.971,0L6.67,6.337a.519.519,0,0,1-.485.332H3.519a.51.51,0,0,0-.32.914L5.1,9.289a.507.507,0,0,1,.169.572L4.572,12.8a.517.517,0,0,0,.79.586L7.939,11.75a.524.524,0,0,1,.6,0l2.577,1.635a.517.517,0,0,0,.79-.586l-.693-2.937a.507.507,0,0,1,.169-.572l1.9-1.707a.51.51,0,0,0-.32-.914H10.3a.518.518,0,0,1-.485-.332L8.726,3.332Z",
    transform: "translate(7.483 10.799)",
    fill: "#07b7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-5",
    "data-name": "Icon akar-star",
    d: "M8.726,3.332a.521.521,0,0,0-.971,0L6.67,6.337a.519.519,0,0,1-.485.332H3.519a.51.51,0,0,0-.32.914L5.1,9.289a.507.507,0,0,1,.169.572L4.572,12.8a.517.517,0,0,0,.79.586L7.939,11.75a.524.524,0,0,1,.6,0l2.577,1.635a.517.517,0,0,0,.79-.586l-.693-2.937a.507.507,0,0,1,.169-.572l1.9-1.707a.51.51,0,0,0-.32-.914H10.3a.518.518,0,0,1-.485-.332L8.726,3.332Z",
    transform: "translate(-2.999 31.641)",
    fill: "#ee480e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-6",
    "data-name": "Icon akar-star",
    d: "M8.726,3.332a.521.521,0,0,0-.971,0L6.67,6.337a.519.519,0,0,1-.485.332H3.519a.51.51,0,0,0-.32.914L5.1,9.289a.507.507,0,0,1,.169.572L4.572,12.8a.517.517,0,0,0,.79.586L7.939,11.75a.524.524,0,0,1,.6,0l2.577,1.635a.517.517,0,0,0,.79-.586l-.693-2.937a.507.507,0,0,1,.169-.572l1.9-1.707a.51.51,0,0,0-.32-.914H10.3a.518.518,0,0,1-.485-.332L8.726,3.332Z",
    transform: "translate(19.322 49.641)",
    fill: "#ee480e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M8115.047-17661.609l-19.619-23.172-4.059,4.906,22.98,19.205Z",
    transform: "translate(-8070.404 17707.367)",
    fill: "#07b7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M8089.316-17697.883c-3.618,12.395,6.236,26.176,6.236,26.176l-1.463,1.461s-10.777-12.855-10.47-20.016,1.078-7.621,1.078-7.621Z",
    transform: "translate(-8046.3 17712.682)",
    fill: "#fcb424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M5.7,27.637C2.085,15.242,11.939,1.462,11.939,1.462L10.477,0S-.3,12.856.006,20.016s1.078,7.621,1.078,7.621Z",
    transform: "translate(41.294 38.835) rotate(93)",
    fill: "#ed3f03"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseConfetti);
export default __webpack_public_path__ + "static/media/ReverseConfetti.a7c953c6.svg";
export { ForwardRef as ReactComponent };